export default function Reputation() {
  const stats = [
    { num: '500万+', label: '注册用户' },
    { num: '10万+', label: '漫画资源' },
    { num: '80万+', label: '日活跃用户' },
    { num: '99.9%', label: '服务可用率' },
  ];

  const testimonials = [
    {
      text: '禁漫天堂是我用过最好用的漫画平台，画质清晰、更新速度快，APP体验也很流畅。VIP会员的离线下载功能简直是为通勤族量身定做的。',
      author: '资深漫画爱好者',
      rating: 5,
    },
    {
      text: '资源非常丰富，日漫、韩漫、国漫应有尽有。分类清晰，搜索方便，推荐算法也很精准，经常能发现符合口味的新作品。',
      author: '日漫粉丝',
      rating: 5,
    },
    {
      text: '支持国产原创这一点让我很感动。在国漫专区看到了很多优秀的本土创作者作品，希望平台越做越好。',
      author: '国漫支持者',
      rating: 5,
    },
    {
      text: '用了两年多了，见证了这个平台不断进步。界面越来越好看，功能越来越完善，客服响应也很及时。',
      author: '老用户',
      rating: 5,
    },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            平台口碑
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            数百万用户的共同选择，禁漫天堂致力于成为最值得信赖的成人漫画平台
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8 mb-14">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6 bg-background-50 rounded-lg">
              <p className="text-2xl md:text-4xl font-heading font-bold text-accent-500 mb-2">
                {stat.num}
              </p>
              <p className="text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-6">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                "{t.text}"
              </p>
              <p className="text-xs text-foreground-500 font-medium">—— {t.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}